module.exports = __webpack_public_path__ + "img/c08_unitsacredcow_Normal_ua.4878ac6c.webp";